import { render, staticRenderFns } from "./pressuresetting.vue?vue&type=template&id=64b00ea1&"
import script from "./pressuresetting.vue?vue&type=script&lang=js&"
export * from "./pressuresetting.vue?vue&type=script&lang=js&"
import style0 from "./pressuresetting.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports